import React from "react";
import "./RequestStatusComponents.css";


export function RequestOpen() {

  return (
    <div className="request-open-main-div">
        <p className="request-status-text">Open Request</p>
    </div>
  );
}

export function RequestComplete() {

    return (
      <div className="request-complete-main-div">
          <p className="request-status-text">Request Complete</p>
      </div>
    );
  }

